export const EDIT_ORDER_INFORMATION_MODAL_ID = 'order-information-modal';
